module.exports = __webpack_public_path__ + "static/media/ic_leucocytes.20d6a66d.svg";